import { ExclamationCircleFilled } from '@ant-design/icons'
import { Alert } from 'antd'

import getColor from '~/lib/getColor'

const ImDfmModalHeaderAlert = () => {
    return (
        <Alert
            message="The DFM for this previous revision is read-only."
            type="info"
            showIcon
            icon={<ExclamationCircleFilled />}
            style={{
                border: 'none',
                width: '100% ',
                borderRadius: 0,
                padding: '10px 10px 10px 36px',
                boxShadow: `inset 0 -1px 0 ${getColor('blackAlpha15')}`,
            }}
        />
    )
}

export default ImDfmModalHeaderAlert
